import * as types from '../../../../lib/actionTypes.es6'

const initialState = {
  payments: null,
  payments_loader: false,
  payments_error: null,

  current_payment: null,
  current_payment_loader: false,
  current_payment_error: null,

  update_status_loader: false,
  update_status_success: false,
  update_status_error: null,

  // guid → { group_name, group_number } and Keycloak user id → display name,
  // accumulated as payments are viewed so guids never reach the screen.
  group_labels: {},
  user_labels: {}
}

export default function omkGroupPaymentReducer(state, action) {
  if (state === undefined) {
    state = initialState
  }
  switch (action.type) {
    case types.GET_GROUP_PAYMENTS_REQUEST:
      return Object.assign({}, state, {
        payments_loader: true,
        payments_error: null
      })
    case types.GET_GROUP_PAYMENTS_SUCCESS:
      return Object.assign({}, state, {
        payments_loader: false,
        payments: action.payload,
        payments_error: null
      })
    case types.GET_GROUP_PAYMENTS_FAILURE:
      return Object.assign({}, state, {
        payments_loader: false,
        payments_error: action.payload
      })

    case types.GET_GROUP_PAYMENT_REQUEST:
      return Object.assign({}, state, {
        current_payment_loader: true,
        current_payment_error: null,
        current_payment: null
      })
    case types.GET_GROUP_PAYMENT_SUCCESS:
      return Object.assign({}, state, {
        current_payment_loader: false,
        current_payment: action.payload,
        current_payment_error: null
      })
    case types.GET_GROUP_PAYMENT_FAILURE:
      return Object.assign({}, state, {
        current_payment_loader: false,
        current_payment_error: action.payload
      })

    case types.UPDATE_GROUP_PAYMENT_STATUS_REQUEST:
      return Object.assign({}, state, {
        update_status_loader: true,
        update_status_success: false,
        update_status_error: null
      })
    case types.UPDATE_GROUP_PAYMENT_STATUS_SUCCESS:
      return Object.assign({}, state, {
        update_status_loader: false,
        update_status_success: true,
        update_status_error: null,
        current_payment: action.payload
      })
    case types.UPDATE_GROUP_PAYMENT_STATUS_FAILURE:
      return Object.assign({}, state, {
        update_status_loader: false,
        update_status_error: action.payload
      })
    case types.UPDATE_GROUP_PAYMENT_STATUS_RESET:
      return Object.assign({}, state, {
        update_status_loader: false,
        update_status_success: false,
        update_status_error: null
      })

    case types.RESOLVE_OMK_PAYMENT_LABELS_SUCCESS:
      return Object.assign({}, state, {
        group_labels: Object.assign(
          {},
          state.group_labels,
          action.payload.groups
        ),
        user_labels: Object.assign({}, state.user_labels, action.payload.users)
      })

    default:
      return state
  }
}
